export default {
    user_id: null,
    user_access: 0,
    is_dev: false,
    prefix_mqtt: '',
    permissions: [],
}
